import DailyIframe, { DailyCall } from '@daily-co/daily-js';
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { useState } from 'react';
import { primaryColor } from '../../../../constants/theme';
import {
  IconArrowAutofitHeight,
  IconArrowAutofitWidth,
  IconMicrophone,
  IconMicrophoneOff,
  IconPhoneEnd,
  IconScreenShare,
  IconVideo,
  IconVideoOff,
} from '@tabler/icons-react';

export interface VideoCallButtonsProps {
  onFitScreen: (isFill: boolean) => void;
  isFill: boolean;
}

const isMobileDevice = () => {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/windows phone/i.test(ua)) {
    return true;
  }

  if (/android/i.test(ua)) {
    return true;
  }

  if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) {
    return true;
  }

  return false;
};

export const VideoCallButtons = ({
  onFitScreen,
  isFill,
}: VideoCallButtonsProps) => {
  // get my current video status
  const [isVideoEnabled, setIsVideoEnabled] = useState(true);
  const [isAudioEnabled, setIsAudioEnabled] = useState(true);
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [callObject, setCallObject] = useState<DailyCall | undefined>(
    DailyIframe.getCallInstance()
  );

  const isMobile = isMobileDevice();

  const toggleVideo = () => {
    if (callObject) {
      callObject.setLocalVideo(!isVideoEnabled);
      setIsVideoEnabled(!isVideoEnabled);
    }
  };

  const toggleAudio = () => {
    if (callObject) {
      callObject.setLocalAudio(!isAudioEnabled);
      setIsAudioEnabled(!isAudioEnabled);
    }
  };

  const endCall = () => {
    if (callObject) {
      callObject.leave().then(() => {
        console.log('Call ended');
      });
    }
  };

  // TODO needs fixing on other end?
  const toggleScreenShare = () => {
    if (callObject) {
      if (isScreenSharing) {
        callObject.stopScreenShare();
        setIsScreenSharing(false);
      } else {
        callObject.startScreenShare();
        setIsScreenSharing(true);
      }
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        width: '100%',
      }}
    >
      <Group gap={20} w="100%" justify="center" mt={10} mb={10}>
        <Tooltip
          label={isFill ? 'View full feed' : 'Fit to screen'}
          position="top"
          withArrow
        >
          <ActionIcon
            size={50}
            radius={25}
            variant="filled"
            color={primaryColor}
            onClick={() => onFitScreen(!isFill)}
          >
            {isFill ? <IconArrowAutofitWidth /> : <IconArrowAutofitHeight />}
          </ActionIcon>
        </Tooltip>
        <Tooltip
          label={isAudioEnabled ? 'Mute' : 'Unmute'}
          position="top"
          withArrow
        >
          <ActionIcon
            size={50}
            radius={25}
            variant="filled"
            color={isAudioEnabled ? primaryColor : 'red'}
            onClick={toggleAudio}
          >
            {isAudioEnabled ? <IconMicrophone /> : <IconMicrophoneOff />}
          </ActionIcon>
        </Tooltip>
        {!isMobile && (
          <Tooltip
            label={isScreenSharing ? 'Stop Sharing' : 'Share Screen'}
            position="top"
            withArrow
          >
            <ActionIcon
              size={50}
              radius={25}
              variant="filled"
              color={isScreenSharing ? 'blue' : primaryColor}
              onClick={toggleScreenShare}
            >
              <IconScreenShare />
            </ActionIcon>
          </Tooltip>
        )}

        <Tooltip
          label={isVideoEnabled ? 'Stop Video' : 'Start Video'}
          position="top"
          withArrow
        >
          <ActionIcon
            onClick={toggleVideo}
            size={50}
            radius={25}
            variant="filled"
            color={isVideoEnabled ? primaryColor : 'red'}
          >
            {isVideoEnabled ? <IconVideo /> : <IconVideoOff />}
          </ActionIcon>
        </Tooltip>
        <Tooltip label="End Call" position="top" withArrow>
          <ActionIcon
            size={50}
            radius={25}
            variant="filled"
            color={'red'}
            onClick={endCall}
          >
            <IconPhoneEnd />
          </ActionIcon>
        </Tooltip>
      </Group>
    </div>
  );
};
